// src/contexts/SubdomainContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSubdomainByAccountId } from '../services/subdomainService';
import { useAuth } from './AuthContext';

const SubdomainContext = createContext(undefined);

export const SubdomainProvider = ({ children }) => {
    const { currentUser, accountId, loading: authLoading } = useAuth();
    const [subdomain, setSubdomain] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasSubdomain, setHasSubdomain] = useState(false);

    useEffect(() => {
        const loadSubdomain = async () => {
            if (authLoading) return; // 認証情報の読み込み完了を待つ

            if (!currentUser || !accountId) {
                setSubdomain(null);
                setHasSubdomain(false);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                const subdomainData = await getSubdomainByAccountId(accountId);

                setSubdomain(subdomainData);
                setHasSubdomain(!!subdomainData);
            } catch (error) {
                console.error('❌ サブドメイン取得エラー:', error);
                setSubdomain(null);
                setHasSubdomain(false);
            } finally {
                setLoading(false);
            }
        };

        loadSubdomain();
    }, [currentUser, accountId, authLoading]);

    // サブドメイン情報を更新する関数
    const refreshSubdomain = async () => {
        if (!currentUser || !accountId) return;

        try {
            setLoading(true);
            const subdomainData = await getSubdomainByAccountId(accountId);
            setSubdomain(subdomainData);
            setHasSubdomain(!!subdomainData);
        } catch (error) {
            console.error('❌ サブドメイン更新エラー:', error);
        } finally {
            setLoading(false);
        }
    };

    const value = {
        subdomain,
        hasSubdomain,
        loading,
        refreshSubdomain
    };

    return (
        <SubdomainContext.Provider value={value}>
            {children}
        </SubdomainContext.Provider>
    );
};

export const useSubdomain = () => {
    const context = useContext(SubdomainContext);
    if (context === undefined) {
        throw new Error('useSubdomain must be used within a SubdomainProvider');
    }
    return context;
};
